import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "results"]
  static values = { url: String, constructionId: String }

  connect() {
    this.timeout = null
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    clearTimeout(this.timeout)
    document.removeEventListener("click", this.handleClickOutside)
  }

  search() {
    clearTimeout(this.timeout)
    this.hiddenTarget.value = ""

    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.hideResults()
      return
    }

    this.timeout = setTimeout(() => this.fetchResults(query), 200)
  }

  async fetchResults(query) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)
    if (this.hasConstructionIdValue && this.constructionIdValue) {
      url.searchParams.set("construction_id", this.constructionIdValue)
    }

    try {
      const response = await fetch(url, {
        headers: { "Accept": "application/json" }
      })
      if (!response.ok) return this.hideResults()
      const materials = await response.json()
      this.renderResults(materials)
    } catch (_) {
      this.hideResults()
    }
  }

  renderResults(materials) {
    const container = this.resultsTarget
    container.replaceChildren()

    if (materials.length === 0) {
      this.hideResults()
      return
    }

    materials.forEach(material => {
      const div = document.createElement("div")
      div.className = "px-3 py-2 cursor-pointer hover:bg-indigo-50 flex items-center justify-between gap-2"
      div.dataset.action = "click->material-autocomplete#select"
      div.dataset.materialId = material.id
      div.dataset.materialName = material.name

      const nameSpan = document.createElement("span")
      nameSpan.className = "text-sm text-gray-900 truncate"
      nameSpan.textContent = material.name
      div.appendChild(nameSpan)

      if (material.catalog) {
        const badge = document.createElement("span")
        badge.className = "shrink-0 text-xs text-indigo-600 bg-indigo-50 px-1.5 py-0.5 rounded font-medium"
        badge.textContent = "Katalog"
        div.appendChild(badge)
      }

      container.appendChild(div)
    })

    container.classList.remove("hidden")
  }

  select(event) {
    const div = event.currentTarget
    this.inputTarget.value = div.dataset.materialName
    this.hiddenTarget.value = div.dataset.materialId
    this.hideResults()
  }

  hideResults() {
    this.resultsTarget.replaceChildren()
    this.resultsTarget.classList.add("hidden")
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }
}
